// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__rHn9x","author":"Table_author__2kMcC","authorImage":"Table_authorImage__jwUD8","unreadRow":"Table_unreadRow__3PLNN"};